import EtiquetaImpressaoService from '../../services/EtiquetaImpressaoService'
import LotesService from '../../services/LotesService'
import { handleRequestError } from '../../shared/utils/RequestUtil'

class EtiquetaImpressaoManager {
    async gerarEtiquetaImpressao(idLote) {
        return await LotesService.gerarEtiquetaImpressao(idLote).then((res) => {
            return res && res.data;
        })
    }

    async possuiTipoConservacao(idLote) {
        return await LotesService.possuiTipoConservacao(idLote).then((res) => {
            return res && res.data;
        })
    }

    async salvarTipoConservacao(idLote, idTipoConservacao) {
        return await LotesService.salvarTipoConservacao(idLote, idTipoConservacao).then((res) => {
            return res && res.data;
        })
    }

    async enviarDadosParaImpressora(dadosImpressao, portaGti, usaApplet) {

        return await EtiquetaImpressaoService.enviarDadosParaImpressora(
            dadosImpressao,
            portaGti, 
            usaApplet
        ).then(resposta => {
            if (resposta && resposta.data && !resposta.data.success) {
                return {
                    mensagem: resposta.data.reason ? resposta.data.reason.userMessage : ''
                };
            }
        })
        .catch(error => {
            
            if (!error.response?.data?.mensagem) {
                error.response = {
                    data: {
                        mensagem: "Ocorreu um erro ao imprimir a etiqueta, verifique suas configurações."
                    }
                };
            }

            handleRequestError(error);
        });
    }
}

export default new EtiquetaImpressaoManager()